import { Injectable } from '@angular/core';
import { StorageException } from '@uzurv/rideWss/app/exceptions';
import { isNullOrUndefined } from '@uzurv/rideWss/app/util';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  async set(key: string, value: any): Promise<boolean> {
    try {
      localStorage.setItem(key, value);

      return true;
    } catch (err) {
      if (isNullOrUndefined(err)) {
        throw new StorageException('Unknown Storage Error');
      }

      throw new StorageException(err.message);
    }
  }

  async get(key: string): Promise<string> {
    try {
      return localStorage.getItem(key);
    } catch (err) {
      if (isNullOrUndefined(err)) {
        throw new StorageException('Unknown Storage Error');
      }

      throw new StorageException(err.message);
    }
  }

  async remove(key: string): Promise<any> {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      if (isNullOrUndefined(err)) {
        throw new StorageException('Unknown Storage Error');
      }

      throw new StorageException(err.message);
    }
  }
}
